import React from 'react';
import { Flex, Text } from '@atlaskit/primitives';
import Tooltip from '@atlaskit/tooltip';
import { useIntl } from '@atlassian/jira-intl';
import { formatTimeLapse } from '../../utils';

type Props = {
	icon: React.ReactElement;
	children?: React.ReactNode;
	title: string;
	issueKey: string;
	lastUpdated: string;
};

export const FailedInfo = ({ icon, children, title, issueKey, lastUpdated }: Props) => {
	const { formatRelativeTime } = useIntl();

	return (
		<Flex gap="space.100" alignItems="center">
			{icon}
			<Flex direction="column" gap="space.050">
				<Flex alignItems="center" gap="space.050">
					<Tooltip content={title} position="top">
						<Text color="color.text" maxLines={1}>
							{title}
						</Text>
					</Tooltip>
					{children}
				</Flex>
				<Flex gap="space.100">
					<Text>{issueKey}</Text>
					<Text>•</Text>
					<Text>{formatTimeLapse(formatRelativeTime, lastUpdated)}</Text>
				</Flex>
			</Flex>
		</Flex>
	);
};
